import { render, staticRenderFns } from "./mobile-configuration.vue?vue&type=template&id=5abb180a&scoped=true&"
import script from "./mobile-configuration.vue?vue&type=script&lang=ts&"
export * from "./mobile-configuration.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-configuration.vue?vue&type=style&index=0&id=5abb180a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb180a",
  null
  
)

export default component.exports